var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCameraIcon = function SvgCameraIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60051 1.45005C1.82647 1.45005 1.20005 2.07647 1.20005 2.85051V10.85C1.20005 11.6241 1.82647 12.2505 2.60051 12.2505H10.6C11.3741 12.2505 12.0005 11.6241 12.0005 10.85V2.85051C12.0005 2.07647 11.3741 1.45005 10.6 1.45005H2.60051ZM0 2.85051C0 1.41405 1.16405 0.25 2.60051 0.25H10.6C12.0365 0.25 13.2005 1.41405 13.2005 2.85051V10.85C13.2005 12.2865 12.0365 13.4505 10.6 13.4505H2.60051C1.91081 13.4505 1.24936 13.1766 0.761671 12.6889C0.273981 12.2012 0 11.5397 0 10.85V2.85051Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9001 4.03067L16.2218 2.10459C16.2789 2.07019 16.344 2.05134 16.4106 2.04991C16.4772 2.04848 16.543 2.06453 16.6015 2.09645C16.66 2.12837 16.7092 2.17505 16.744 2.23185C16.7789 2.28865 16.7982 2.35359 16.8002 2.4202V11.2814C16.8002 11.555 16.4882 11.753 16.2218 11.5982L12.9013 9.6721L12.2988 10.7101L15.6194 12.6362C16.6502 13.2338 18.0003 12.5222 18.0003 11.2814V2.4202C18.0003 1.18055 16.6502 0.468923 15.6194 1.06655L12.3 2.99263L12.9025 4.03067H12.9001Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCameraIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cameraIcon.819c844f.svg";
export { ForwardRef as ReactComponent };